export function parseDashboardNumeric(value) {
  if (value == null || value === "") {
    return null;
  }
  if (typeof value === "number") {
    return Number.isNaN(value) ? null : value;
  }
  const cleaned = String(value).replace(/,/g, "").trim();
  if (cleaned === "") {
    return null;
  }
  const num = parseFloat(cleaned);
  return Number.isNaN(num) ? null : num;
}
